import { render, staticRenderFns } from "./DealArrangements.vue?vue&type=template&id=e4ea23aa&"
import script from "./DealArrangements.vue?vue&type=script&lang=ts&"
export * from "./DealArrangements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4ea23aa')) {
      api.createRecord('e4ea23aa', component.options)
    } else {
      api.reload('e4ea23aa', component.options)
    }
    module.hot.accept("./DealArrangements.vue?vue&type=template&id=e4ea23aa&", function () {
      api.rerender('e4ea23aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/DealArrangements.vue"
export default component.exports